module.exports = __webpack_public_path__ + "static/media/Blue-Force-Marketing.bfcf6004.png";